export const mapMessages = (messages) =>
  messages.map((message) => ({
    ...message,
    message: message.message.replace(/\r?\n/g, '')
  }))
